import { render, staticRenderFns } from "./OtherProceedingList.vue?vue&type=template&id=dc161866&scoped=true&"
import script from "./OtherProceedingList.vue?vue&type=script&lang=js&"
export * from "./OtherProceedingList.vue?vue&type=script&lang=js&"
import style0 from "./OtherProceedingList.vue?vue&type=style&index=0&id=dc161866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc161866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VDataTable,VIcon,VSelect,VTextField})
